import { render, staticRenderFns } from "./ReckonStatistic.vue?vue&type=template&id=66be44e2&"
import script from "./ReckonStatistic.vue?vue&type=script&lang=js&"
export * from "./ReckonStatistic.vue?vue&type=script&lang=js&"
import style0 from "./ReckonStatistic.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports